
const addGdprPrivacyPolicy = () => {
  if (!document.querySelector('.js-custom-form__contact-checkbox-block')) return;
  var groupEnrollmentNonGdrpMessage = document.querySelector('.js-non-gdpr-countries-privacy-policy');
  if (!groupEnrollmentNonGdrpMessage) return;
  var privacyPoliciesLabel = document.querySelector('label[for="custom_form_entry_agree"]');
  privacyPoliciesLabel.style.display = 'block';
  var privacyPoliciesLink = document.createElement('a');
  privacyPoliciesLink.id = 'group-enrollment-gdpr-privacy-policy-link';
  privacyPoliciesLink.href = 'https://emeritus.org/privacy-policy/';
  privacyPoliciesLink.title = 'Privacy Policy';
  privacyPoliciesLink.target = '_blank';
  privacyPoliciesLink.classList.add('group-enrollment-gdpr-privacy-policy-link');
  var linkText = document.createTextNode('Privacy Policy');
  privacyPoliciesLink.appendChild(linkText);
  privacyPoliciesLabel.appendChild(privacyPoliciesLink);
};

export default addGdprPrivacyPolicy;
